<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>

        <div v-else>
        <vue-headful :title="sheet.data_sheet_name + ' [Safety Data Sheet] :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0 d-block d-md-inline-block">
                    <li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                        <router-link :to="`/safety-data-sheets`">
                            <i class="fa fa-files-o"></i> Safety Data Sheets
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">
                        {{ sheet.data_sheet_name }}
                    </li>
                </ol>
            </h4>

            <div class="row mb-4">
                <div class="col-xl-8 col-lg-12">
                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>Safety Data Sheet</strong>

                            <div class="float-sm-right mt-sm-0 mt-3" v-if="canEdit">
                                <router-link :to="`/safety-data-sheets/edit/${sheet.id}`" class="btn btn-sm btn-light">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link>
                                <router-link :to="`/safety-data-sheets/delete/${sheet.id}`" class="btn btn-sm btn-light">
                                    <span class="text-danger"><i class="fa fa-trash"></i> Delete</span>
                                </router-link>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row mb-sm-2 mb-3">
                                <div class="col-md-4 text-md-right text-muted">Data Sheet Name:</div>
                                <div class="col-md-8">
                                    {{ sheet.data_sheet_name }}
                                </div>
                            </div>
                            <div class="row mb-sm-2 mb-3">
                                <div class="col-md-4 text-md-right text-muted">Manufacturer:</div>
                                <div class="col-md-8">
                                    {{ sheet.manufacturer_name }}
                                </div>
                            </div>
                            <div class="row mb-sm-2 mb-3">
                                <div class="col-md-4 text-md-right text-muted">Supplier:</div>
                                <div class="col-md-8">
                                    {{ sheet.supplier_name }}
                                </div>
                            </div>
                            <div class="row mb-sm-2 mb-3">
                                <div class="col-md-4 text-md-right text-muted">Product Code:</div>
                                <div class="col-md-8">
                                    {{ sheet.product_code }}
                                </div>
                            </div>
                            <div class="row mb-sm-2 mb-3">
                                <div class="col-md-4 text-md-right text-muted">CAS#:</div>
                                <div class="col-md-8">
                                    {{ sheet.cas_nbr }}
                                </div>
                            </div>
                            <div class="row mb-sm-2 mb-3">
                                <div class="col-md-4 text-md-right text-muted">Active:</div>
                                <div class="col-md-8">
                                    <label class="badge badge-success" v-if="sheet.is_active == 1">Active</label>
                                    <label class="badge badge-warning" v-else>Inactive</label>
                                </div>
                            </div>
                            <div class="row mb-sm-2 mb-3">
                                <div class="col-md-4 text-md-right text-muted">Current Revision:</div>
                                <div class="col-md-8">
                                    <a :href="`/files/view/${sheet.current_file_id}`" target="_blank" title="View or Download Sheet in a New Tab">{{ sheet.file_name }}</a>
                                </div>
                            </div>
                            <div class="row mb-sm-2 mb-3">
                                <div class="col-md-4 text-md-right text-muted">Current Revision Date:</div>
                                <div class="col-md-8">
                                    {{ sheet.current_file_created | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-12">
                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>Catalogs ({{ sheet.catalogs.length }})</strong>
                        </div>
                        <div class="card-body">
                            <div v-for="catalog in sheet.catalogs" class="mb-2">
                                <router-link :to="`/safety-data-sheets/catalogs/view/${catalog.id}`" title="View Catalog">{{ catalog.catalog_name }}</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <b-tabs class="nav-tabs-top mb-4">
                <b-tab active>
                    <template slot='title'>
                        <i class="fa fa-building"></i> Jobsites
                    </template>
                    <b-card-body>
                        <jobsite-list assetType="SafetyDataSheet" :assetId="id" />
                    </b-card-body>
                </b-tab>
                <b-tab>
                    <template slot='title'>
                        <i class="fa fa-clock"></i> Revisions ({{ files.length }})
                    </template>
                    <b-card-body>
                        <template v-if="files.length > 0">
                            <file-list :files="files" boxSize="col-xl-12 col-md-6 col-12" />
                        </template>
                        <template v-else>
                            -- No Files --
                        </template>
                    </b-card-body>
                </b-tab>
            </b-tabs>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                id: this.$route.params.id,
                userTimezone: this.$store.state.user.timezone,
                sheet: {},
                files: [],
            }
        },

        computed: {

            canEdit(){
                //Check for manager
                if(this.$root.hasPermission('safety.data_sheets.manage'))
                {
                    return true;
                }

                //Default Defense
                return false;
            },

        },

        methods: {

            getSafetyDataSheet: function() {
                //Get the data
                this.$http
                    .get('/safety-data-sheets/view/' + this.id)
                    .then(response => {
                        //Set all the data
                        this.sheet = response.data.sheet;
                        this.files = response.data.files;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

        },
        mounted() {
            //Get the Safety Data Sheet
            this.getSafetyDataSheet();
        }
    }
</script>
